<div class="mat-dialog-container-in">
  <div class="dialog-box create-dialog-box">
    <div class="dialog-icon dialog-icon-warning mr-0 ng-star-inserted"></div>
    <div class="dialog-content">
      <div class="custom-h1"></div>
      <div mat-dialog-content>
        <div  class="mat-dialog-content">{{ 'report_error_header' | translate}}: {{text}}</div>
      </div>
      <div>
        <button class="ok" mat-dialog-close>OK</button>
      </div>
    </div>
  </div>
</div>
